import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const userModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem('user_token') || ''
  },
  mutations: {
    SET_TOKEN(state, { token }) {
      state.token = token
      localStorage.setItem('user_token', token)
    },
    LOGOUT(state) {
      state.token = ''
      localStorage.removeItem('user_token')
    }
  }
}

const salesModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem('sales_token') || '',
    user: JSON.parse(localStorage.getItem('sales_user') || '{}')
  },
  mutations: {
    SET_TOKEN(state, { token }) {
      state.token = token
      localStorage.setItem('sales_token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('sales_user', JSON.stringify(user))
    },
    LOGOUT(state) {
      state.token = ''
      state.user = {}
      localStorage.removeItem('sales_token')
      localStorage.removeItem('sales_user')
    }
  }
}

export default new Vuex.Store({
  modules: {
    user: userModule,
    sales: salesModule
  }
})
